// extracted by mini-css-extract-plugin
export default {"link":"TopicUserRow-module__link--rO2Vx","name":"TopicUserRow-module__name--xgNpf","badgeContainer":"TopicUserRow-module__badgeContainer--Nvaql"};